import { Sheet } from "@mui/joy";

export default function EmptyPage() {
  return (
    <Sheet
      sx={{
        backgroundColor: "white",
        width: "100%",
        height: "100%",
        display: "flex",
        flexDirection: "row",
        justifyContent: "center",
        alignItems: "center",
      }}
    ></Sheet>
  );
}
